import { gql, MutationHookOptions, useMutation } from "@apollo/client";

import { ReportFragment, REPORT_FRAGMENT } from "../../fragments";
import { InsertReportUserMutationVariables } from "../../types";

export const INSERT_REPORT_USER = gql`
  mutation insertReportUser($input: InsertReportUserInput!) {
    insertReportUser(input: $input) {
      report {
        ...ReportFragment
      }
    }
  }
  ${REPORT_FRAGMENT}
`;

export type ReportData = { insertReportUser: { report: ReportFragment } };

export default (
  options?: MutationHookOptions<ReportData, InsertReportUserMutationVariables>
) => {
  return useMutation<ReportData, InsertReportUserMutationVariables>(
    INSERT_REPORT_USER,
    options
  );
};
